import { render, staticRenderFns } from "./interacciongueno.vue?vue&type=template&id=4514b4d4"
import script from "./interacciongueno.vue?vue&type=script&lang=js"
export * from "./interacciongueno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports